import { bnplConsumerApis } from "@payping/api";
import type { SDKRequestInit } from "@payping/api";
import { Flex, useMessagedAsyncFn } from "@payping/web-components";
import { dashboardReduxReducerActions } from "@/redux/actions/dashboard";
import { RetryGetOrderSteps } from "@/redux/reducers/dashboard";
import { useAppDispatch } from "@/utils";
import PayGetOrderUploadSignatureDraw from "./Draw";
import PayExpiredOrder from "../../ExpiredOrder";
import PayGetOrderUploadSignatureUnAvailable from "./UnAvailable";
import PayGetOrderLayout from "../Layout";
import PayGetOrderIssuePromissoryFailed from "../IssuePromissory/Failed";

interface UploadSignatureProps {
  trackingCode: string;
  afterSuccess: () => void;
}

const PayGetOrderUploadSignature = ({ afterSuccess, trackingCode }: UploadSignatureProps) => {
  const dispatch = useAppDispatch();
  const [uploadSignatureState, uploadSignature] = useMessagedAsyncFn(
    async ({ signatureImage }: { signatureImage: File }) => {
      try {
        await bnplConsumerApis.uploadSignature(trackingCode, signatureImage, {
          isRaw: true,
        } as SDKRequestInit);
        afterSuccess();
      } catch (e: any) {
        if (e.status === 400) {
          try {
            const parsedError = await e.json();
            throw parsedError;
          } catch (jsonError: any) {
            if (jsonError.status === 400) {
              throw jsonError;
            }
            throw e;
          }
        }
        throw e;
      }
    },
    [trackingCode, afterSuccess],
  );

  // expired order
  if ((uploadSignatureState.error as any)?.key === 109) {
    return (
      <PayGetOrderLayout showHeaders={false}>
        <PayExpiredOrder />
      </PayGetOrderLayout>
    );
  }

  // error in generate issue
  if ((uploadSignatureState.error as any)?.key === 107 && (uploadSignatureState.error as any)?.detail) {
    return (
      <PayGetOrderLayout showHeaders currentStepError>
        <PayGetOrderIssuePromissoryFailed
          onRetry={() => {
            dispatch(dashboardReduxReducerActions.setRetryGetOrder(RetryGetOrderSteps.startGetOrder));
          }}
          message={(uploadSignatureState.error as any)?.detail}
        />
      </PayGetOrderLayout>
    );
  }

  if (uploadSignatureState.error) {
    return (
      <PayGetOrderLayout showHeaders={false} currentStepError>
        <PayGetOrderUploadSignatureUnAvailable />
      </PayGetOrderLayout>
    );
  }

  // if (successStep.show && successStep.image) {
  //   return (
  //     <PayGetOrderLayout showHeaders>
  //       <Success data={successStep.image} onFinish={() => afterSuccess()} />
  //     </PayGetOrderLayout>
  //   );
  // }

  return (
    <PayGetOrderLayout showHeaders>
      <Flex className="tw:w-full tw:px-4! tw:pb-4! tw:pt-6!">
        <PayGetOrderUploadSignatureDraw
          // 50kb
          maxSize={50 * 1024}
          onFinish={(file) => {
            uploadSignature({ signatureImage: file });
          }}
          loading={uploadSignatureState.loading}
        />
      </Flex>
    </PayGetOrderLayout>
  );
};

export default PayGetOrderUploadSignature;
